// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useUniqueId } from '@tectonics/hooks/use-unique-id';
import { useSubmitting } from '@tectonics/prs/submitting';
import { useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { useUserInputAsCheckbox } from '@tectonics/prs/user-input-values';
import { merchantHasOneClickConfig } from '@tectonics/prs/merchant/config/credit-card-one-click';
import { Checkbox } from '../../../../../atoms';

export function SaveOneClickCard(): Node {
  const { t } = useTranslation('volcanes');

  const incomingPayment = useIncomingPayment();
  const inputId = useUniqueId();
  const submitting = useSubmitting();
  const [, setSaveCardOneClick] = useUserInputAsCheckbox('saveCardOneClick');
  const [selectedPaymentMethod] = useUserInputAsCheckbox('selectedPaymentMethod');
  const isNotCreditCard = selectedPaymentMethod !== 'creditcard';

  if (!merchantHasOneClickConfig(incomingPayment) || isNotCreditCard) {
    return null;
  }

  return (
    <div data-test-name="save-one-click-card">

      <Checkbox
        id={inputId}
        readOnly={submitting}
        name="saveCardOneClick"
        onChange={setSaveCardOneClick}
      />

      <SaveCardCheckboxLabel htmlFor={inputId}>
        {t('payment-methods.card.oneClick.saveCardCheckboxLabel')}
      </SaveCardCheckboxLabel>

    </div>
  );
}

const SaveCardCheckboxLabel = styled.label`
  margin-left: 1em;
`;
